import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type ContactTagConnection } from "@/lib/types";
import { baseContactRoute } from "./contact";

export const createContactTagConnectionV1 = (
  data: Pick<ContactTagConnection, "contactId" | "tagId"> &
    Partial<ContactTagConnection>,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<ContactTagConnection>
    >(`${baseContactRoute}/tags/connections`, data)
    .then((res) => res.data);
};

export const deleteContactTagConnectionV1 = (
  data: Pick<ContactTagConnection, "id" | "contactId">,
) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<ContactTagConnection>
    >(`${baseContactRoute}/tags/connections/${data.id}`)
    .then((res) => res.data);
};
